<template>
  <div :class="`${if_selected} ${clazz} w-100`">
    <div class="md-layout">
      <label for="name">
        <b class="md-layout-item md-caption">{{ tx(model) }}</b></label
      >
      <helpWidget
        style="float: right"
        class="md-layout-item"
        :help="help_key"
      ></helpWidget>
    </div>
    <br />
    <round-slider
      v-model="sliderValue"
      editableTooltip="false"
      start-angle="0"
      end-angle="+360"
      line-cap="round"
      :radius="width"
      :min="min"
      :max="max"
      :step="step"
      :rangeColor="
        this.type_component == 'output' ? this.outputColor : this.inputColor
      "
      :tooltip-format="sliderTooltipFormatter"
    />
  </div>
</template>

<script>
import RoundSlider from "vue-round-slider";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "valve-input-component",
  mixins: [inputComponentMixin],
  components: { RoundSlider },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sliderValue: 0,
      min: 0,
      max: 100,
      step: 0,
      width: 0,
      if_selected: "",
    };
  },
  watch: {
    sliderValue(oldval, val) {
      //update value with sliderValue model in round slider
      if (this.customValues.length > 0) {
        this.value = this.customValues[this.sliderValue];
      } else {
        this.value = this.sliderValue;
      }
    },
  },
  async mounted() {
    //initialize model value
    if (this.customValues.length > 0) {
      this.sliderValue = this.customValues.indexOf(this.attributes.defaut);
    } else {
      this.sliderValue = this.attributes.defaut;
    }

    this.update_selected();

    // write attributes for valve ( round-slider ). For values in array , min and max are range of tick
    // example: array [2,10,14,31] have min 0 and max 3
    Bus.$on("selected-changed", () => {
      this.update_selected();
      this.min = this.attributes.min;
      this.max = this.attributes.max;
      this.step = this.attributes.step;
      this.width = this.attributes.width;
    });
  },
  computed: {
    sliderObj() {
      return this.$refs.slider1.instance;
    },
    // read the list of values from xml layout
    customValues() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    },
    // read if valve has a component parent.
    // this valve is show only if parent component select the dependance value
    id_selected_tab() {
      if (this.attributes.id_selected === undefined) return [];
      else return this.attributes.id_selected.split("|");
    },
  },
  methods: {
    sliderTooltipFormatter: function (e) {
      return this.customValues[e.value];
    },
  },
};
</script>
